import { Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { ServiceDetail } from './pages/ServiceDetail';
import { Impact } from './pages/Impact';
import { Blog } from './pages/Blog';
import { BlogDetail } from './pages/BlogDetail';
import { Contact } from './pages/Contact';
import { Donate } from './pages/Donate';
import { NotFound } from './pages/NotFound';
import { ScrollToTop } from './components/ScrollToTop';

export function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <ScrollToTop />
      <Helmet>
        <title>Punarvaa | Structured Waste Recovery Systems | Patekar Recycle</title>
        <meta
          name="description"
          content="Punarvaa by Patekar Recycle Solution Pvt Ltd builds structured systems to recover value from waste. Compliant waste management, recycling, and resource recovery solutions."
        />
        <meta property="og:title" content="Punarvaa | Structured Waste Recovery Systems" />
        <meta
          property="og:description"
          content="Building structured systems to recover value from waste. For businesses, cities, and the planet."
        />
        <meta property="og:site_name" content="Punarvaa by Patekar Recycle" />
        <meta property="og:url" content="https://www.patekarecycle.com" />
        <meta name="theme-color" content="#00B194" />
      </Helmet>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:serviceId" element={<ServiceDetail />} />
        <Route path="/impact" element={<Impact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:blogId" element={<BlogDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}
